var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showIcon)?_c('span',{class:_vm.$style.iconStyle},[_c('Icon',{attrs:{"icon":"premiumDiscover"}})],1):_vm._e(),_c('span',{attrs:{"data-test-id":"PremiumFeatureIcon__label"}},[_vm._v(" "+_vm._s(_vm.iconLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }